$(".gallery__item--colorbox").colorbox({
	maxWidth: "95%",
	maxHeight: "95%",
});
